const KEY = "cpt_consent_v1";

export const DEFAULT_CONSENT = { necessary: true, statistics: false, marketing: false };

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed.grants, at: parsed.at, version: parsed.version };
  } catch {
    return null;
  }
}

export function saveConsent(grants) {
  const payload = { version: 1, at: new Date().toISOString(), grants: { ...grants, necessary: true } };
  localStorage.setItem(KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent("cpt-consent-change", { detail: payload }));
  return payload;
}

export function hasConsent(category) {
  const c = readConsent();
  return category === "necessary" ? true : !!(c && c[category]);
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event("cpt-open-cookie-preferences"));
}
